import { t } from 'i18next';
import { palette } from '../../material-ui/palette';

export enum IssueReportLabelState {
    OPEN = 'open',
    IN_PROGRESS = 'in progress',
    ON_HOLD = 'on hold',
    DONE = 'done',
}

export const setIssueReportChipColor = (label: string) => {
    switch (label) {
        case IssueReportLabelState.OPEN:
            return palette.chip.open;
        case IssueReportLabelState.IN_PROGRESS:
            return palette.chip.inProgress;
        case IssueReportLabelState.ON_HOLD:
            return palette.chip.onHold;
        case IssueReportLabelState.DONE:
            return palette.chip.done;
        default:
            return palette.chip.inProgress;
    }
};

export const setIssueReportLabelText = (label: string) => {
    switch (label) {
        case IssueReportLabelState.OPEN:
            return t('issue_reports.card.open') as string;
        case IssueReportLabelState.IN_PROGRESS:
            return t('issue_reports.card.in_progress') as string;
        case IssueReportLabelState.ON_HOLD:
            return t('issue_reports.card.on_hold') as string;
        case IssueReportLabelState.DONE:
            return t('issue_reports.card.resolved') as string;
        default:
            return t('issue_reports.card.open') as string;
    }
};
